import React, {useEffect} from "react";
import "./index.css"

import { CaretUpOutlined ,CaretDownOutlined} from '@ant-design/icons';
import emiter, {
    EVENT_CARRENTAL_STORE_RATING,
    EVENT_CARRENTAL_STORE_TEXT
} from "../../../../events";


interface PropsType {
    enums?: any;
    errorContent?: string;
}

const SPStoreRatingTotal: React.FC<PropsType> = (props) => {
    const {errorContent} = props;
    const showTimeEmpty = '----/--/--';
    const showTextEmpty = '--'

    const [showText, setShowText] = React.useState({
        opening_ceremony:'--',
        total_content:'--'
    });
    const [nowRating, setNowRating] = React.useState<any>('--');
    const [totalRating, setTotalRating] = React.useState('--');
    const [monthOnMonth, setMonthOnMonth] = React.useState<any>('--');
    const [nowTime, setNowTime] = React.useState('----/--/--');

    const loadTotalInfo = (data:any) =>{
        let { score, total_score, score_rate, date} = data;
        setNowRating(score);
        setTotalRating(total_score)
        setMonthOnMonth(score_rate)
        setNowTime(date)
    }
    const showRecordActivities = (text:string,score:string) =>{
        return <>
            {
                text.replace(score,'ω').split('ω').map((item:string,index:number)=> {
                    return index == 0 ?
                        <span key={index}>{item}<span className='scoreLimit'>{score}</span></span>
                        :
                        <span key={index}>{item}</span>
                })
            }
        </>
        return
    }
    const updateShowText = (data:any) => {
        if(Object.keys(data).length>0){
            setShowText({...data})
        }
    }
    useEffect(() => {
        emiter.on(EVENT_CARRENTAL_STORE_TEXT, updateShowText)
        emiter.on(EVENT_CARRENTAL_STORE_RATING, loadTotalInfo)
    }, [])
    return (
        <div className='totalBody'>
            <div style={{fontSize: 13,marginBottom:5}} title={nowTime ? '' : errorContent}>*分数更新时间：{nowTime ?? showTimeEmpty} 0点
            </div>
            <div className='totalHeader'>
                门店评分：
                <div title={ nowRating ? '' : errorContent }>
                    <span className='nowRating'>{ nowRating ?? showTextEmpty }</span>
                    <span style={{fontSize:'17px'}}>/{ totalRating ?? showTextEmpty }</span>
                    <span>分</span>
                </div>
                <div className='monthOnMonth'>
                    日环比
                    {
                        !monthOnMonth ? <span title={errorContent}>{showTextEmpty}%</span>
                        : monthOnMonth < 0 ?
                        <>下降
                            <span className='monthOnMonthBottom'><CaretDownOutlined/>{Math.abs(monthOnMonth)}%</span>
                        </>
                        :
                        <>上涨
                            <span className='monthOnMonthTop'><CaretUpOutlined/>{monthOnMonth}%</span>
                        </>
                    }
                </div>
            </div>
            <div style={{paddingLeft: '120px'}} >{nowRating < 68 && showRecordActivities(showText?.['opening_ceremony'],'68分')}</div>
            <div style={{margin: '13px 0 18px',whiteSpace:'pre-wrap'}} title={showText?.['total_content'] ? '' : errorContent}>{showText?.['total_content'] ?? showTextEmpty}</div>
        </div>
    )
}
export default SPStoreRatingTotal;